import { render } from "./msgCenter.vue?vue&type=template&id=6eae5192&scoped=true"
import script from "./msgCenter.vue?vue&type=script&lang=js"
export * from "./msgCenter.vue?vue&type=script&lang=js"

import "./msgCenter.vue?vue&type=style&index=0&id=6eae5192&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eae5192"]])

export default __exports__